import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'pm-site-layout',
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.scss']
})
export class SiteLayoutComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
    document.documentElement.className = 'site';
    const element: HTMLLinkElement = document.querySelector('#flaticon');
    element.href = '/assets/fonts/flaticon/flaticon.css';
  }

}
